import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import {
  Checkbox,
  IconButton,
  ListItem,
  ListItemIcon,
  ListItemText,
  makeStyles
} from '@material-ui/core';
import { Star, StarBorder } from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
  listItem: {
    padding: theme.spacing(0.25, 0)
  },
  checkbox: {
    padding: theme.spacing(0.5)
  },
  starButton: {
    padding: theme.spacing(0.5)
  },
  starSelected: {
    color: theme.palette.warning.main
  }
}));

const RoleSelectionRow = ({
  roleUri,
  displayText,
  isChecked,
  isDefault,
  onToggle,
  onSetDefault
}) => {
  const classes = useStyles();
  const handleToggle = useCallback(() => onToggle({ roleUri, displayText }), [
    onToggle,
    roleUri,
    displayText
  ]);
  const handleSetDefault = useCallback(() => onSetDefault(roleUri), [
    onSetDefault,
    roleUri
  ]);

  return (
    <ListItem disableGutters className={classes.listItem}>
      <ListItemIcon>
        <Checkbox
          className={classes.checkbox}
          size="small"
          checked={isChecked}
          onChange={handleToggle}
          color="primary"
        />
      </ListItemIcon>
      <ListItemText primary={displayText} />
      <IconButton
        className={classes.starButton}
        size="small"
        disabled={!isChecked}
        onClick={handleSetDefault}
      >
        {isDefault ? (
          <Star fontSize="small" className={classes.starSelected} />
        ) : (
          <StarBorder fontSize="small" />
        )}
      </IconButton>
    </ListItem>
  );
};

RoleSelectionRow.propTypes = {
  roleUri: PropTypes.string.isRequired,
  displayText: PropTypes.string.isRequired,
  isChecked: PropTypes.bool.isRequired,
  isDefault: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  onSetDefault: PropTypes.func.isRequired
};

export default RoleSelectionRow;
